import { useAuth } from '@clerk/clerk-react'
import { useEffect } from 'react'
import { setAuthTokenGetter } from '../../lib/api'

interface ApiProviderProps {
    children: React.ReactNode
}

export function ApiProvider({ children }: ApiProviderProps) {
    const { getToken } = useAuth()

    useEffect(() => {
        // Set up the token getter function for the API client
        setAuthTokenGetter(async () => {
            try {
                // Get the JWT token from Clerk
                const token = await getToken()
                return token
            } catch (error) {
                console.error('Failed to get Clerk token:', error)
                return null
            }
        })
    }, [getToken])

    return <>{children}</>
} 